"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LanguageContext = undefined;

var _react = require("react");

// create the language context with default selected language
var LanguageContext = exports.LanguageContext = (0, _react.createContext)({
    userLanguage: 'vi'
});